<template>
    <div
        class="group relative aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100"
    >
      <blur-hash
          v-if="file?.mime_type.includes('image/')"
          :hash="file.custom_properties?.blur_hash"
          :src="file.original_url"
          :alt="file.custom_properties?.description ?? file.name"
          class="aspect-w-10 aspect-h-7"
      />
        <div v-else-if="file?.mime_type.includes('video/')" class="text-indigo-700 pointer-events-none group-hover:opacity-75">
            <div class="flex flex-col justify-center h-full text-gray-300 items-center relative">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="absolute w-24 h-24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
                </svg>

                <video :src="file.original_url" class="h-full object-cover" />
            </div>
        </div>
        <div v-else class="flex flex-col justify-center items-center pointer-events-none bg-indigo-100 text-indigo-700 object-cover group-hover:opacity-75">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
            <span>Unknown media type</span>
        </div>
    </div>
</template>

<script setup>

import FormattedSize from "@/ComponentsDeprecated/FormattedSize.vue";
import BlurHash from "@/ComponentsDeprecated/BlurHash.vue";

const props = defineProps({
    file: {
        type: Object,
        required: true
    }
})
</script>
